module.exports = __webpack_public_path__ + "static/js-8c8e5b478a997b5edf07267a22d57410.png";